<template>
  <div class="search-container">
    <div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input size="small" v-model="name" placeholder="请输入商品名称"></el-input>
        </el-col>
        <el-col :span="8">
          <el-select size="small" v-model="customCateId" placeholder="请选择分类">
            <el-option v-for="cateItem in customCateList" :label="cateItem.name" :value="cateItem.shopDecorateId" :key="cateItem.shopDecorateId"></el-option>
          </el-select>
        </el-col>
        <el-col :span="7">
          <el-button size="small" type="primary" @click="searchClick">搜索</el-button>
          <el-button size="small" @click="resetClick">重置</el-button>
        </el-col>
      </el-row>
    </div>
    <div>
      <a :href="`${scLink}mj/exportExcel.do`" class="mar15-r" target="_blank">
        <el-button size="small" type="primary">导出EXCEL</el-button>
      </a>
      <el-button size="small" type="primary" @click="newCreateClick">新建商品</el-button>
    </div>
  </div>
</template>

<script>
import { getGoodsShopCategory } from "@/api/publishGoods/publishGoods";

export default {
  props: {
    selfOperatedShop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: "",
      scLink: process.env.VUE_APP_APP,
      customCateId: "",
      customCateList: [],
    };
  },
  created() {
    this.loadGetGoodsShopCategory();
  },
  methods: {
    async loadGetGoodsShopCategory() {
      const result = await getGoodsShopCategory();
      this.customCateList = result.data;
    },
    searchClick() {
      this.$emit("searchClick", { name: this.name, customCateId: this.customCateId });
    },
    resetClick() {
      this.name = "";
      this.customCateId = "";
      this.$emit("resetClick");
    },
    newCreateClick() {
      this.$router.push("publishgoods");
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
